const Registry = (function () {

    var self = {};

        /**
         * array containing registered data
         *
         * @type {Array}
         */
    var data = [];

    /**
     * Adds data to the registry. It does not allow overriding values.
     *
     * @param {String} key
     * @param {*} value
     * @return {*}
     */
    self.add = function (key, value) {
        if (data[key]) {
            return false;
        }

        data[key] = value;

        return this;
    };

    /**
     * Adds data to the registry. It overrides values.
     *
     * @param {String} key
     * @param {*} value
     * @return {boolean}
     */
    self.set = function (key, value) {
        data[key] = value;

        return true;
    };

    /**
     * Get registered value by it's key
     *
     * @param {String} key
     * @return {*}
     */
    self.get = function (key) {

        if (typeof data[key] !== 'undefined') {
            return data[key];
        }

        return undefined;
    };

    return self;
})();

const w = window;

w.Registry = Registry;
w.home24 = w.home24 || {};
w.home24.Registry = Registry;

export function add(key, value) {
    return Registry.add(key, value);
}

export function set(key, value) {
    return Registry.set(key, value);
}

export function get(key) {
    return Registry.get(key);
}



/** WEBPACK FOOTER **
 ** ./legacy/home24/core/registry.js
 **/